import makeStyles from "@mui/styles/makeStyles";
import createStyles from "@mui/styles/createStyles";
import { colors } from "@zapalacorp/tokens";

const useStyles = makeStyles(() =>
  createStyles({
    accUserLogo: {
      width: "120px",
      height: "120px",
      backgroundColor: "#f6f9fc",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      borderRadius: "50%",
    },
    accUserLogoImg: {
      width: "90.5px",
      height: "87.94px",
    },
    noMemberHeading: {
      fontSize: "22px",
      color: colors.gray500,
      fontWeight: 400,
      marginTop: "2rem",
    },
    noMemberSubheading: {
      fontSize: "16px",
      fontWeight: 400,
      color: colors.gray500,
      marginBottom: "24px",
      maxWidth: "445px",
      textAlign: "center",
    },
  })
);

export default useStyles;
